import gql from 'graphql-tag';
export const KnowledgeCategoryFragment = gql`
  fragment KnowledgeCategoryFragment on knowledgeCategories_Entry {
    id
    typeHandle
    title
    slug
    image {
      url
    }
    seoTopics
  }
`;

export const RelatedArticlesQuery = gql`
  query RelatedArticlesQuery($site: String!, $related: [QueryArgument]) {
    entries(site: [$site], section: "article", relatedToAll: $related) {
      ...ArticlePreviewFragment
    }
  }
`;

export default {
  data() {
    return {
      category: null,
      articles: [],
    };
  },
  methods: {},
};
